import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useAppContext } from '../../../hooks/AppContext';
import { NumberInput } from 'carbon-components-react';
import { segmentTracking } from '../../../lib/tracker';
import messages from 'src/apps/envizi-price-estimator/locales/messages';
import { stepProps } from './Step1';
import { createUseTranslation } from '../../../../../common/hooks/widgets/useTranslation';
import { useEnviziSelector } from '../../../lib/redux/hooks';

const Step2 = ({ isOpen, showPrice, q1Val }: stepProps) => {
  const { appAction } = useAppContext();

  const [value, setValue] = useState('10');
  const facilityRef = useRef() as MutableRefObject<HTMLInputElement>;
  const updateValue = () => {
    setValue(facilityRef.current.value);
    segmentTracking('CTA Clicked', {
      pageTitle: 'Envizi Price Estimator',
      object: 'Envizi page',
      resultValue: 'CTA clicked',
      CTA: 'Location/Facilities input',
      location: 'Assessment',
      action: '',
      field: '',
    });
    appAction({
      type: 'answerInput',
      answerId: 'Q2A1',
      answerValue: `${facilityRef.current.value} Cookie-${facilityRef.current.value}`,
    });
    appAction({ type: 'next', queId: 'Q2' });
  };

  const AEMMessages = useEnviziSelector((state) => state.translations.messages);
  const useTranslation = createUseTranslation(messages, AEMMessages);

  useEffect(() => {
    appAction({
      type: 'answerInput',
      answerId: 'Q2A1',
      answerValue: `${value} Cookie-${value}`,
    });
  }, [q1Val]);

  return isOpen ? (
    <>
      <h3 className="label-heading padding_8">
        {useTranslation('que2_label')}
      </h3>
      <NumberInput
        id="latency"
        size="md"
        min={1}
        ref={facilityRef}
        allowEmpty={false}
        invalid={false}
        helperText={''}
        disabled={showPrice}
        className="number-input calc-input"
        value={Number(value)}
        onChange={() => updateValue()}
        onBlur={() => {
          null;
        }}
        onFocus={() => {
          null;
        }}
      />
    </>
  ) : null;
};

export default Step2;
